/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable import/first */
import type { ReactNode, ReactElement } from 'react';

import { forwardRef } from 'react';
import type { ForwardedRef } from 'react';
// material
import { useTheme } from '@mui/material/styles';
import { Fab } from '@mui/material';
//
import { ButtonAnimate } from '../animate';

const FabComponent = Fab as any;

export interface MFabProps {
  children?: ReactNode;
  sx?: Record<string, any>;
  color?: string;
  [key: string]: any;
}

// ----------------------------------------------------------------------

const MFab = forwardRef(function MFabImpl(
  { color = 'primary', children, sx, ...other }: MFabProps,
  ref: ForwardedRef<HTMLElement>
) {
  const theme = useTheme();

  if (
    color === 'default' ||
    color === 'inherit' ||
    color === 'primary' ||
    color === 'secondary'
  ) {
    return (
      <ButtonAnimate>
        <FabComponent ref={ref} color={color} sx={sx} {...other}>
          {children}
        </FabComponent>
      </ButtonAnimate>
    );
  }

  return (
    <ButtonAnimate>
      <FabComponent
        ref={ref}
        sx={{
          // @ts-ignore legacy boundary
          boxShadow: theme.customShadows[color],
          color: theme.palette[color].contrastText,
          bgcolor: theme.palette[color].main,
          '&:hover': {
            bgcolor: theme.palette[color].dark,
          },
          ...sx,
        }}
        {...other}
      >
        {children}
      </FabComponent>
    </ButtonAnimate>
  );
});

export default MFab;
